import React, { useEffect, useState } from 'react';
import { User } from './userList';

interface UserFormProps {
  onSubmit: (formData: User) => void;
  initialData?: User | undefined;
}

interface UserFormErrors {
  name: string;
  email: string;
  password: string;
  role: string;
}

const UserForm: React.FC<UserFormProps> = ({ onSubmit, initialData }) => {
  const [formData, setFormData] = useState<User>(
    initialData || { id: 0, name: '', email: '', role: 'USER', password: '' },
  );
  const [errors, setErrors] = useState<Partial<UserFormErrors>>({});

  useEffect(() => {
    setFormData(initialData || { id: 0, name: '', email: '', role: 'USER', password: '' });
  }, [initialData]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    console.log('name', name, 'value', value);
    setFormData({
      ...formData,
      [name]: name === 'employees' ? Number(value) : value,
    });
  };

  const validate = () => {
    const newErrors: Partial<UserFormErrors> = {};

    if (!formData.name) newErrors.name = 'Name is required';
    if (formData.name.length > 100) {
      newErrors.name = 'Name must be less than 100 characters';
    }
    if (!['USER', 'ADMIN'].includes(formData.role)) {
      newErrors.role = 'Location is required to be USER or ADMIN';
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (validate()) {
      onSubmit(formData);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label>
          Name:
          <input
            type="text"
            name="name"
            id="name"
            value={formData.name}
            onChange={handleChange}
          />
        </label>
        {errors.name && <p style={{ color: 'red' }}>{errors.name}</p>}
      </div>
      <div>
        <label>
          Email:
          <input
            type="text"
            name="email"
            id="email"
            value={formData.email}
            onChange={handleChange}
          />
        </label>
        {errors.email && <p style={{ color: 'red' }}>{errors.email}</p>}
      </div>
      <div>
        <label htmlFor="role">Role: </label>
        <select
          id="role"
          name="role"
          value={formData.role}
          onChange={handleChange}
        >
          <option value="ADMIN">ADMIN</option>
          <option value="USER">USER</option>
        </select>
        {errors.role && <p style={{ color: 'red' }}>{errors.role}</p>}
      </div>
      <button type="submit">Submit</button>
    </form>
  );
};

export default UserForm;
